/**
 * Created by evgenijsenkevic on 8/7/25
 */

Mission.REGISTRATIONS.set(Mission.TYPE_LIGHTNING_RUSH, () => ({
    available: cleverapps.config.availables.LIGHTNING_RUSH_MISSION,
    logic: LightningRushLogic,
    view: LightningRushStartWindow,
    guideWindow: {
        name: "LightningRushGuideWindow",
        bundle: bundles.lightning_rush_guide_window
    },
    schedule: "MON-FRI",
    name: "LightningRush",
    rowView: cleverapps.config.type === "merge2" ? function (row) {
        return Prefab.instantiate(bundles.merge.jsons.lightning_rush_row_prefab_json, { mission: row.data.mission });
    } : undefined,
    teaser: true,
    semaphore: Mission.SEMAPHORE_ALWAYS,
    collectIcon: bundles.tournament_icon.frames.lighting_rush_icon,
    sideBarJson: bundles.sidebar.jsons.lighting_rush_icon_json,
    competition: {
        algo: PersonalBestBotAlgorithm,
        speedType: PersonalBestBotAlgorithm.SpeedType.PerMinute,
        avgSpeed: "lightning",
        amount: 4,
        forceCoef: [90, 120]
    },
    oneWinner: true,
    prize: RewardsConfig.LightningRush,
    startWindow: LightningRushStartWindow,
    markView: cleverapps.config.type === "merge2" && LightningRushMarkMerge2,
    bundle: "lighting_rush"
}));

cleverapps.InitByFeature["lighting_rush"] = function () {
    cleverapps.tutorial.register(LightningRushTutorial());
};